import React from 'react';
import { Dimmer, Loader, Segment, Placeholder } from 'semantic-ui-react';

const loadingPanelStyle = {
  marginTop: '20px'
};

const CorpusPlaceholder = () => (
  <Segment style={loadingPanelStyle}>
    <Dimmer active inverted>
      <Loader size="large">Cargando ejemplos</Loader>
    </Dimmer>
    <Placeholder fluid>
      <Placeholder.Line length="full" />
      <Placeholder.Line length="full" />
      <Placeholder.Line length="full" />
      <Placeholder.Line length="full" />
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
      <Placeholder.Line length="full" />
      <Placeholder.Line length="full" />
      <Placeholder.Line length="full" />
      <Placeholder.Line length="full" />
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
      <Placeholder.Line length="full" />
      <Placeholder.Line length="full" />
      <Placeholder.Line length="full" />
      <Placeholder.Line length="full" />
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
    </Placeholder>
  </Segment>
);

export default CorpusPlaceholder;
